export default () => {
    return useFetchWithTanstackQuery({
        queryKey: ['consumerPreferences'],
        queryFn: () => $fetch('/api/marketing/communication/consumerPreferences'),
    })
}
